import type { ShortCode } from '@highereducation/wordpress';
import { SponsoredCardAdapter } from './SponsoredCardAdapter';

/**
 * WordPress shortcode: `hen-ui-sponsored-card`
 *
 * Renders the hen-ui `SponsoredCard` with string attributes from the editor.
 *
 * @example
 * ```text
 * [hen-ui-sponsored-card
 *   logo-src="https://example.com/logo.svg"
 *   logo-alt="Example University"
 *   name="Example University"
 *   name-href="/schools/example"
 *   visit-href="https://example.edu"
 *   visit-label="Visit Site"
 *   sponsor-label="Sponsored Partner"
 *   sponsored-visit="true"
 *   about-heading="About this School"
 *   meta-items="Austin, TX|4-year|On Campus"
 * ]
 * <p>Optional HTML blurb from the CMS.</p>
 * [/hen-ui-sponsored-card]
 * ```
 */
export const SponsoredCardShortcode: ShortCode = {
  component: SponsoredCardAdapter as ShortCode['component'],
};
